<div
  class="itinerary-course-item"
  [ngClass]="{
    'itinerary-course-item--withalert': course.withdrawn || unavailableCourse
  }"
>
  <button *ngIf="!hideButtons" type="button" class="un-btn itinerary-course-item__drag">
    <span class="glicon-drag"></span>
  </button>
  <div class="itinerary-course-item__main">
    <div
      class="itinerary-course-item__image"
      [ngStyle]="{
        'background-image': imageUrl ? 'url(' + imageUrl + ')' : '',
        'background-position-x': bannerMobilePosition + 'px'
      }"
    ></div>
    <div class="itinerary-course-item__data">
      <div class="itinerary-course-item__title">{{ course.name }}</div>
      <div class="itinerary-course-item__content">
        <div>
          <div class="itinerary-course-item__strong">{{ 'nouns.creator' | translate }}</div>
          <div class="itinerary-course-item__ellipsis">{{ course.clientName || course.creator }}</div>
        </div>
        <div>
          <div class="itinerary-course-item__strong">
            {{ 'nouns.topic' | translate }}
          </div>
          <div class="itinerary-course-item__ellipsis">{{ course.topic }}</div>
        </div>
        <div>
          <div class="itinerary-course-item__strong">
            {{ 'nouns.duration' | translate }}
          </div>
          <div>
            {{ course.hours ? course.hours + 'h' : course.minutes ? '' : '0h' }}
            {{ course.minutes ? course.minutes + 'min' : '' }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="itinerary-course-item__actions">
    <button
      *ngIf="course.withdrawn"
      type="button"
      lmsTooltip
      [tooltipConfig]="{ positionV: 'top', positionH: 'right', text: ['itineraries.course.withdrawn' | translate] }"
      class="un-btn itinerary-course-item__alert"
    >
      <span class="glicon-alert"></span>
    </button>
    <button
      *ngIf="unavailableCourse"
      type="button"
      lmsTooltip
      [tooltipConfig]="{ positionV: 'top', positionH: 'right', text: ['itineraries.course.unavailable' | translate] }"
      class="un-btn itinerary-course-item__alert"
    >
      <span class="glicon-alert"></span>
    </button>
    <button *ngIf="!hideButtons" (click)="delete()" type="button" class="un-btn itinerary-course-item__delete">
      <span class="glicon-trash"></span>
    </button>
  </div>
</div>
